<footer class="footer d-none d-md-block">
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-6">AstroBin, &copy; 2010 - {{ currentYear }}</div>

      <div class="col-12 col-md-6 build-date">Build: {{ version }}</div>
    </div>
  </div>
</footer>
